<template>
  <VTooltip
    v-if="tooltip"
    :class="getClass"
    :autoHide="getAutoHide"
    :placement="getPlacement"
    style="width: 50px"
    :triggers="getTrigger"
  >
    <appAwesomeIcon
      v-if="tooltip && !getIsMobile"
      icon="info-circle"
      useClass="fa fa-info-circle"
    ></appAwesomeIcon>
    <appAwesomeIcon
      v-if="tooltip && getIsMobile"
      icon="info-circle"
      useClass="fa fa-info-circle"
    ></appAwesomeIcon>
    <template #popper>
      <span v-html="tooltipContent"></span>
    </template>
  </VTooltip>
</template>
<script>
import AwesomeIcon from "./AwesomeIcon.vue";

export default {
  components: {
    appAwesomeIcon: AwesomeIcon
  },
  props: {
    tooltip: {
      type: String,
      default() {
        return null;
      }
    },
    tooltipContent: {
      type: String,
      default() {
        return "";
      }
    },
    isPoptext: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    getClass: function () {
      let className = "matrix_tooltipContainer";
      if (this.isPoptext) {
        className += " matrix_tooltipContainerIsPoptext";
      }
      return className;
    },
    getIsMobile: function () {
      return window.innerWidth <= 990;
    },
    getPlacement: function () {
      return "top";
      // return "left" for mobile
    },
    getTrigger: function () {
      return ["hover"];
      // for mobile
      //return ["click"];
    },
    getAutoHide: function () {
      return true;
    }
  },
  methods: {
    getTriggerEvent: function (tooltip) {
      return {
        content: tooltip,
        trigger: this.getIsMobile ? "click" : "hover",
        autoHide: false
      };
    }
  }
};
</script>
